import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderByPipe } from './orderBy.pipe';
import { KeysPipe, ValuesPipe } from './value.pipe';
import { YearsOldByDatePipe } from './years-old-by-date/years-old-by-date.pipe';
import { PercentComputePipe } from "libraries/pipes/percent-compute.pipe";
import { SeverityStatusToIconPipe } from './severity-status-to-icon/severity-status-to-icon.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        OrderByPipe,
        KeysPipe,
        ValuesPipe,
        YearsOldByDatePipe,
        PercentComputePipe,
        SeverityStatusToIconPipe,
    ],
    exports: [
        OrderByPipe,
        KeysPipe,
        ValuesPipe,
        YearsOldByDatePipe,
        PercentComputePipe,
        SeverityStatusToIconPipe,
    ],
})
export class PipesModule {
}
